(function (angular) {
    'use strict';

    angular.module('Common')
        .factory('totpService', ['$http', 'portalConfig', '$q',
            function ($http, portalConfig, $q) {

                var service = {};

                function httpGetRequest(apiUrl, successHandler) {
                    var deferred = $q.defer();

                    $http.get(apiUrl)
                        .then(function (response) {
                            if (successHandler) {
                                successHandler(response);
                            }
                            deferred.resolve(response.data);
                        })
                        .catch(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function httpPostRequest(apiUrl, requestData, successHandler) {
                    var deferred = $q.defer();

                    $http.post(apiUrl, requestData)
                        .then(function (response) {
                            if (successHandler) {
                                successHandler(response);
                            }
                            deferred.resolve(response.data);
                        })
                        .catch(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function httpPutRequest(apiUrl, requestData, successHandler) {
                    var deferred = $q.defer();

                    $http.put(apiUrl, requestData)
                        .then(function (response) {
                            if (successHandler) {
                                successHandler(response);
                            }
                            deferred.resolve(response.data);
                        })
                        .catch(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                service.isTotpActivated = function(idsBag) {
                    var apiUrl = `${portalConfig.urlBase}/accounts/${idsBag.accountId}/users/${idsBag.userId}/totp-activated`;
                    return httpGetRequest(apiUrl);
                };

                service.getTotpStatus = function(idsBag) {
                    var apiUrl = `${portalConfig.urlBase}/accounts/${idsBag.accountId}/users/${idsBag.userId}/get-totp-status`;
                    return httpGetRequest(apiUrl);
                };       

                service.generateTotp = function (idsBag) {
                    var apiUrl = `${portalConfig.urlBase}/accounts/${idsBag.accountId}/users/${idsBag.userId}/generate-totp`;
                    return httpPostRequest(apiUrl, {});
                };

                service.verifyTotp = function (idsBag, authcode) {
                    var apiUrl = `${portalConfig.urlBase}/accounts/${idsBag.accountId}/users/${idsBag.userId}/verify-totp`;
                    var data = {
                        authCode: authcode
                    };

                    return httpPostRequest(apiUrl, data).then((response) => {
                        return {
                            data: {
                                userId: response.userId,
                                status: response.status,
                                token: response.token
                            }
                        };
                    });
                };

                service.updateTotpStatus = function(idsBag, totpStatus) {
                    var apiUrl = `${portalConfig.urlBase}/accounts/${idsBag.accountId}/users/${idsBag.userId}/update-totp-status`;

                    httpPutRequest(apiUrl, {
                        totpStatus: totpStatus
                    })
                    .catch(function(error) {
                        console.error("Error while updating TOTP:", error);
                    });
                }

                return service;
            }
        ]);

})(window.angular);